/// <reference types="@shopify/polaris-types" />

export function BalanceDisplay({
  credits,
  dollarValue,
  reloading = false,
}: {
  credits: number;
  dollarValue: string;
  reloading?: boolean;
}) {
  return (
    <>
      <s-stack direction="block" gap="small-100">
        <s-text color="subdued">El saldo de tu cuenta</s-text>
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            gap: "8px",
            margin: "4px 0",
          }}
        >
          <span
            style={{
              fontSize: "40px",
              fontWeight: 700,
              color: "#202223",
              lineHeight: 1,
            }}
          >
            {credits.toLocaleString("es")}
          </span>
          <span style={{ fontSize: "18px", color: "#6d7175" }}>créditos</span>
          <span style={{ fontSize: "14px", color: "#8c9196" }}>
            · ${dollarValue} USD
          </span>
          {reloading && <s-spinner accessibility-label="Actualizando…" />}
        </div>
        <s-text color="subdued">
          Cada crédito cuesta $0.025 · se descuenta por sesión usada
        </s-text>
      </s-stack>
      <div style={{ borderTop: "1px solid #f1f2f3", margin: "20px 0" }} />
    </>
  );
}
